import React from 'react';
import './HeaderSE.css';
import Logo from '../../../assets/rewboxlogo3.png';
import { Link } from 'react-router-dom';

const HeaderSE = ({ backcolor = `rgb(0, 100, 200)` }) => {
  return (
    <div
      className="sr-header-container"
      style={{ background: `linear-gradient(to right, ${backcolor}, #005BBB)` }}
    >
      <div className="header-left-item">
        <img className="header-logo1" src={Logo} alt="Logo"></img>
      </div>
      <div className="header-right-item">
        <Link to="/se/villkor" target="_blank" rel="noopener noreferrer">
          VILLKOR
        </Link>
      </div>
    </div>
  );
};

export default HeaderSE;
